<template>
  <div class="sidebar-wrapper" :class="{ toggled: toggled }">
    <!-- Floating Bubbles Background -->
    <ul class="circles">
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
    </ul>

    <ul class="navbar-nav sidebar accordion" id="accordionSidebar">
      <!-- Sidebar - Brand -->
      <router-link to="/home" class="sidebar-brand-link">
        <div
          class="sidebar-brand d-flex align-items-center justify-content-center"
        >
          <div class="sidebar-brand-icon">
            <img class="img-profile" src="/logo.png" width="50" alt="Logo" />
          </div>
          <div class="sidebar-brand-text mx-3">Events Admin</div>
        </div>
      </router-link>

      <!-- Divider -->
      <hr class="sidebar-divider my-0" />

      <!-- Nav Item - Dashboard -->
      <li class="nav-item">
        <router-link
          to="/dashboard"
          class="nav-link"
          active-class="active-link"
          exact
        >
          <i class="fas fa-fw fa-tachometer-alt"></i>
          <span>Dashboard</span>
        </router-link>
      </li>

      <hr class="sidebar-divider" />

      <div class="sidebar-heading">Event Management</div>

      <li class="nav-item">
        <router-link
          to="/amenity/list"
          class="nav-link"
          active-class="active-link"
        >
          <i class="fas fa-fw fa-concierge-bell"></i>
          <span>Amenities</span>
        </router-link>
      </li>

      <li class="nav-item">
        <router-link
          to="/plan-amenity/list"
          class="nav-link"
          active-class="active-link"
        >
          <i class="fas fa-fw fa-clipboard-list"></i>
          <span>Plan Amenities</span>
        </router-link>
      </li>

      <li class="nav-item">
        <router-link
          to="/event-participant/list"
          class="nav-link"
          active-class="active-link"
        >
          <i class="fas fa-fw fa-users"></i>
          <span>Participants</span>
        </router-link>
      </li>

      <li class="nav-item">
        <router-link
          to="/idcard/idcard-print-list"
          class="nav-link"
          active-class="active-link"
        >
          <i class="fas fa-fw fa-id-card"></i>
          <span>Print ID Card</span>
        </router-link>
      </li>

      <li class="nav-item">
        <router-link
          to="/idcard/update-idcard-upload"
          class="nav-link"
          active-class="active-link"
        >
          <i class="fas fa-fw fa-upload"></i>
          <span>Update ID Card No</span>
        </router-link>
      </li>

      <li class="nav-item">
        <router-link
          to="/conference-event/list"
          class="nav-link"
          active-class="active-link"
        >
          <i class="fas fa-fw fa-calendar-alt"></i>
          <span>Conference Events</span>
        </router-link>
      </li>

      <li class="nav-item">
        <router-link
          to="/conference-registration/list"
          class="nav-link"
          active-class="active-link"
        >
          <i class="fas fa-fw fa-user-check"></i>
          <span>Registration</span>
        </router-link>
      </li>

      <li class="nav-item">
        <router-link
          to="/conference-news/list"
          class="nav-link"
          active-class="active-link"
        >
          <i class="fas fa-fw fa-newspaper"></i>
          <span>News & Updates</span>
        </router-link>
      </li>
      <li class="nav-item">
        <router-link
          to="/conference-sponsor/list"
          class="nav-link"
          active-class="active-link"
        >
          <i class="fas fa-fw fa-handshake"></i>
          <span>Sponsor</span>
        </router-link>
      </li>
      <hr class="sidebar-divider" />

      <div class="sidebar-heading">Analytics & Reports</div>

      <li class="nav-item">
        <a
          class="nav-link collapsed"
          href="#"
          data-toggle="collapse"
          data-target="#collapseReports"
          aria-expanded="true"
          aria-controls="collapseReports"
        >
          <i class="fas fa-fw fa-chart-pie"></i>
          <span>Reports</span>
        </a>
        <div
          id="collapseReports"
          class="collapse"
          aria-labelledby="headingUtilities"
          data-parent="#accordionSidebar"
        >
          <div class="py-2 collapse-inner rounded">
            <h6 class="collapse-header">Generated Reports:</h6>
            <router-link to="/report/amenity-given" class="collapse-item"
              >Amenity Given</router-link
            >
            <router-link to="/report/participant-report" class="collapse-item"
              >Participant Report</router-link
            >
          </div>
        </div>
      </li>

      <hr class="sidebar-divider" />
      <div class="sidebar-heading">Administration</div>
      <li class="nav-item">
        <router-link
          to="/user/list"
          class="nav-link"
          active-class="active-link"
        >
          <i class="fas fa-fw fa-users-cog"></i>
          <span>Users</span>
        </router-link>
      </li>

      <hr class="sidebar-divider d-none d-md-block" />
    </ul>
  </div>
</template>

<script>
export default {
  name: "SidebarMenu",
  props: {
    toggled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
/* Main Sidebar Container */
.sidebar-wrapper {
  background: linear-gradient(180deg, #0780f8 0%, #021a70 100%);
  min-height: 100vh;
  width: 100px;
  /* Collapsed width */
  min-width: 100px;
  box-shadow: 4px 0 25px rgba(0, 0, 0, 0.1);
  position: relative;
  overflow: hidden;
  transition: width 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  z-index: 1000;
  /* Ensure it stays on top if needed */
}

.sidebar-wrapper:hover {
  width: 280px;
  /* Expanded width */
}

.sidebar {
  padding: 0;
  list-style: none;
  position: relative;
  z-index: 1;
  width: 280px;
  /* Ensure content doesn't wrap awkwardly during transition */
}

/* Floating Bubbles Animation */
.circles {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  margin: 0;
  padding: 0;
  z-index: 0;
}

.circles li {
  position: absolute;
  display: block;
  list-style: none;
  width: 20px;
  height: 20px;
  background: rgba(255, 255, 255, 0.3);
  border: 3px solid rgba(255, 255, 255, 0.5);
  animation: animate 25s linear infinite;
  bottom: -150px;
  border-radius: 50%;
}

.circles li:nth-child(1) {
  left: 25%;
  width: 80px;
  height: 80px;
  animation-delay: 0s;
}

.circles li:nth-child(2) {
  left: 10%;
  width: 20px;
  height: 20px;
  animation-delay: 2s;
  animation-duration: 12s;
}

.circles li:nth-child(3) {
  left: 70%;
  width: 20px;
  height: 20px;
  animation-delay: 4s;
}

.circles li:nth-child(4) {
  left: 40%;
  width: 60px;
  height: 60px;
  animation-delay: 0s;
  animation-duration: 18s;
}

.circles li:nth-child(5) {
  left: 65%;
  width: 20px;
  height: 20px;
  animation-delay: 0s;
}

.circles li:nth-child(6) {
  left: 75%;
  width: 110px;
  height: 110px;
  animation-delay: 3s;
}

.circles li:nth-child(7) {
  left: 35%;
  width: 150px;
  height: 150px;
  animation-delay: 7s;
}

.circles li:nth-child(8) {
  left: 50%;
  width: 25px;
  height: 25px;
  animation-delay: 15s;
  animation-duration: 45s;
}

.circles li:nth-child(9) {
  left: 20%;
  width: 15px;
  height: 15px;
  animation-delay: 2s;
  animation-duration: 35s;
}

.circles li:nth-child(10) {
  left: 85%;
  width: 150px;
  height: 150px;
  animation-delay: 0s;
  animation-duration: 11s;
}

@keyframes animate {
  0% {
    transform: translateY(0) rotate(0deg);
    opacity: 1;
    border-radius: 0;
  }

  100% {
    transform: translateY(-1000px) rotate(720deg);
    opacity: 0;
    border-radius: 50%;
  }
}

/* Brand Section */
.sidebar-brand-link {
  text-decoration: none;
}

.sidebar-brand {
  height: 5rem;
  text-decoration: none;
  font-size: 1.2rem;
  font-weight: 800;
  padding: 1.5rem 1rem;
  text-align: center;
  text-transform: uppercase;
  letter-spacing: 0.05rem;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.sidebar-brand-text {
  display: none;
  /* Hide by default */
  opacity: 0;
  transition: opacity 0.3s ease;
}

.sidebar-wrapper:hover .sidebar-brand-text {
  display: block;
  opacity: 1;
}

.sidebar-brand-icon img {
  transition: transform 0.3s ease;
}

.sidebar-brand:hover .sidebar-brand-icon img {
  transform: scale(1.1) rotate(-5deg);
}

/* Dividers & Headings */
.sidebar-divider {
  border-top: 1px solid rgba(255, 255, 255, 0.15);
  margin: 0 1rem 1rem;
}

.sidebar-heading {
  color: rgba(255, 255, 255, 0.6);
  font-size: 0.75rem;
  font-weight: bold;
  text-transform: uppercase;
  padding: 0 1.5rem;
  margin-bottom: 0.5rem;
  letter-spacing: 0.05em;
  display: none;
  /* Hide by default */
}

.sidebar-wrapper:hover .sidebar-heading {
  display: block;
  animation: fadeIn 0.5s;
}

/* Nav Items */
.nav-item {
  position: relative;
  margin-bottom: 0.25rem;
}

.nav-link {
  display: flex;
  align-items: center;
  justify-content: center;
  /* Center icon when collapsed */
  padding: 0.8rem 0;
  /* Reduced padding for collapsed */
  color: rgba(255, 255, 255, 0.85) !important;
  font-weight: 500;
  font-size: 0.95rem;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  border-left: 4px solid transparent;
  position: relative;
  overflow: hidden;
  text-decoration: none;
}

.sidebar-wrapper:hover .nav-link {
  justify-content: flex-start;
  /* Align left when expanded */
  padding: 0.8rem 1.5rem;
}

.nav-link i {
  margin-right: 0;
  /* No margin when collapsed */
  font-size: 1.1rem;
  width: 1.5rem;
  text-align: center;
  transition: all 0.3s ease;
}

.sidebar-wrapper:hover .nav-link i {
  margin-right: 1rem;
  /* Restore margin */
}

.nav-link span {
  display: none;
  /* Hide text by default */
  opacity: 0;
  white-space: nowrap;
}

.sidebar-wrapper:hover .nav-link span {
  display: inline-block;
  opacity: 1;
  animation: fadeIn 0.3s;
}

/* Hover Effects with Bubble Animation */
.nav-link::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 50%;
  transform: translate(-50%, -50%);
  transition: width 0.5s ease, height 0.5s ease;
  z-index: 0;
}

.nav-link:hover::before {
  width: 350px;
  height: 350px;
}

.nav-link:hover {
  color: #fff !important;
}

.sidebar-wrapper:hover .nav-link:hover {
  padding-left: 1.8rem;
  /* Slide effect only when expanded */
}

.nav-link:hover i {
  transform: scale(1.2);
  color: #fff;
}

.nav-link span,
.nav-link i {
  position: relative;
  z-index: 1;
}

/* Active State */
.active-link {
  background: rgba(255, 255, 255, 0.15);
  color: #fff !important;
  border-left: 4px solid #fff;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  font-weight: 700;
}

.active-link i {
  color: #fff;
}

/* Collapse Menu */
.collapse-inner {
  background: rgba(0, 0, 0, 0.1);
  /* Semi-transparent dark background */
  box-shadow: none;
  margin: 0 1rem 1rem;
  border-radius: 0.35rem;
  overflow: hidden;
  animation: fadeIn 0.3s ease;
}

.collapse-header {
  margin: 0;
  white-space: nowrap;
  padding: 0.5rem 1.5rem;
  text-transform: uppercase;
  font-weight: 800;
  font-size: 0.65rem;
  color: rgba(255, 255, 255, 0.6);
  /* Light text */
}

.collapse-item {
  padding: 0.5rem 1.5rem;
  margin: 0 0.5rem;
  display: block;
  color: rgba(255, 255, 255, 0.8);
  /* White text */
  text-decoration: none;
  border-radius: 0.35rem;
  white-space: nowrap;
  font-size: 0.85rem;
  transition: all 0.2s;
}

.collapse-item:hover,
.collapse-item.router-link-active {
  background-color: rgba(255, 255, 255, 0.15);
  /* Subtle hover highlight */
  color: #fff;
  font-weight: 700;
  padding-left: 1.8rem;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Responsive Toggler (Optional, if used) */
#sidebarToggle {
  width: 2.5rem;
  height: 2.5rem;
  text-align: center;
  margin-bottom: 1rem;
  cursor: pointer;
}

@media (max-width: 768px) {
  .sidebar-wrapper {
    width: 0 !important;
    min-width: 0 !important;
    overflow: hidden;
  }

  .sidebar-wrapper.toggled {
    width: 250px !important;
    min-width: 250px !important;
  }

  /* Ensure content is visible when toggled */
  .sidebar-wrapper.toggled .sidebar-brand-text,
  .sidebar-wrapper.toggled .sidebar-heading,
  .sidebar-wrapper.toggled .nav-link span {
    display: inline-block;
    opacity: 1;
  }

  .sidebar-wrapper.toggled .nav-link {
    justify-content: flex-start;
    padding: 0.8rem 1.5rem;
  }

  .sidebar-wrapper.toggled .nav-link i {
    margin-right: 1rem;
  }
}
</style>
